/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Lpdataroom_Error3Inputs */

const en_coinvestments_lpdataroom_error3 = /** @type {(inputs: Coinvestments_Lpdataroom_Error3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to load data room`)
};

/**
* | output |
* | --- |
* | "Failed to load data room" |
*
* @param {Coinvestments_Lpdataroom_Error3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_lpdataroom_error3 = /** @type {((inputs?: Coinvestments_Lpdataroom_Error3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Lpdataroom_Error3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_lpdataroom_error3(inputs)
});
export { coinvestments_lpdataroom_error3 as "coInvestments_lpDataRoom_error" }